/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSamplingDataForProducedMaterialEntry } from '../../models/create-sampling-data-for-produced-material-entry';

export interface CreateSamplingDataForProducedMaterial$Params {
  workCenterId: number;
  producedMaterialId: number;
      body: CreateSamplingDataForProducedMaterialEntry
}

export function createSamplingDataForProducedMaterial(http: HttpClient, rootUrl: string, params: CreateSamplingDataForProducedMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createSamplingDataForProducedMaterial.PATH, 'post');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('producedMaterialId', params.producedMaterialId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createSamplingDataForProducedMaterial.PATH = '/api/v1/QaCheck/{workCenterId}/CreateSamplingDataForProducedMaterial/{producedMaterialId}';
